































import { Component, Mixins } from "vue-property-decorator";
import { DomainRegistry } from "../../../../domain";
import { ImageSourceKinds, IDocumentImageSource, ImageKinds } from "../../../../domain/document";
import { instanceOfIImageDrawable, ImageItem } from "../../../../domain/document/items";
import { DrawableItemEditorMixin, CommonComponentsAccessibleMixin } from "../mixins";
import { PropertyEditableMixin, DrawerPropertyEditableMixin } from "./mixins";
import PrintBehaviorEditor from "./PrintBehaviorEditor.vue";
import QuotationEditor from "./QuotationEditor.vue";

@Component({
  components: {
    printBehaviorEditor: PrintBehaviorEditor,
    quotationEditor: QuotationEditor,
  },
})
export default class ImagePropertyEditor extends Mixins(
  PropertyEditableMixin,
  DrawableItemEditorMixin,
  DrawerPropertyEditableMixin,
  CommonComponentsAccessibleMixin,
) {
  editingSource: ImageItem;

  get imageSource(): IDocumentImageSource {
    return instanceOfIImageDrawable(this.editingSource)
      ? this.editingSource.imageSource
      : undefined;
  }

  set imageSource(source: IDocumentImageSource) {
    this.writeProperty((s: ImageItem) => {
      s.clearImageInformation();
      s.replaceImageSource(source);
      s.imageKind = ImageKinds.Image;
    });
  }

  get isClearable(): boolean {
    return (this.imageSource.imageSourceKind !== ImageSourceKinds.None)
      && !!this.imageSource.imageSourceKind;
  }

  clearSource(): void {
    const repository = DomainRegistry.document.getDocumentRepository();
    repository.createEmptyImageSource()
    .then(source => {
      this.writeProperty((s: ImageItem) => {
        s.clearImageInformation();
        s.replaceImageSource(source);
      });
    });
  }

  selectFile(): void {
    this.commonComponents.dialogs.imageFileUploader.show()
      .then(s => {
        if (!!s) {
          this.imageSource = s;
        }
      })
      .catch(e => {
        this.$error(
          "画像ファイル選択失敗",
          "画像ファイル選択中にエラーが発生しました。"
        );
      });
  }

  rotateImage(): void {
    const currentAngle = !!this.editingSource.rotationAngle ? this.editingSource.rotationAngle : 0;
    const rotatedAngle = Number(currentAngle) + 90;
    const nextAndle = (rotatedAngle >= 360) ? rotatedAngle - 360 : rotatedAngle;
    this.writeProperty(s => {
      s.rotationAngle = nextAndle;
    });
  }
}
